import { BulkGoalCreationResult, BulkStore } from '../types'
import {
  getStoreEligibility,
  getStoreEligibilityFailureMessage
} from './storeEligibility'

interface BuildSubmissionPlanInput {
  selectedStoreIds: Set<string>
  selectedStores: BulkStore[]
  storesAvailabilityById: Map<string, BulkStore>
}

export interface SubmissionPlan {
  storesToSubmit: BulkStore[]
  unavailableResults: BulkGoalCreationResult[]
}

export const buildSubmissionPlan = ({
  selectedStoreIds,
  selectedStores,
  storesAvailabilityById
}: BuildSubmissionPlanInput): SubmissionPlan => {
  const selectedStoresById = new Map(selectedStores.map(store => [store._id, store]))

  return Array.from(selectedStoreIds).reduce<SubmissionPlan>((plan, storeId) => {
    const selectedStore = selectedStoresById.get(storeId)
    const availableStore = storesAvailabilityById.get(storeId)
    const eligibility = getStoreEligibility(availableStore)
    const resultStore = availableStore || selectedStore

    if (!eligibility.canSubmit) {
      plan.unavailableResults.push(buildUnavailableResult(
        storeId,
        resultStore,
        getStoreEligibilityFailureMessage(eligibility.reason)
      ))
      return plan
    }

    plan.storesToSubmit.push(availableStore!)
    return plan
  }, { storesToSubmit: [], unavailableResults: [] })
}

const buildUnavailableResult = (
  storeId: string,
  store: BulkStore | undefined,
  errorMessage: string
): BulkGoalCreationResult => ({
  errorMessage,
  storeId,
  storeName: store?.name || 'Loja selecionada',
  success: false
})
